<template>
    <!-- More information about GAPS here: https://w.amazon.com/bin/view/Pumas-team/OurOfferings/AccountSwitchers -->
    <div
        id="dropdown-account-switcher-container"
        data-mode="default"
        data-nature="vendorGroup"
        data-test-tag="dropdown-account-switcher-container"
    >
        <a
            class="account-switcher-fallback"
            href="/account-switcher/default/vendorGroup"
            data-test-tag="account-switcher-fallback"
        >
            {{ $t('header_accountSwitcher_switchAccounts') }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'AccountSwitcherLoader',
    methods: {
        appendScriptsToDom() {
            const idPrefix = 'dropdown-account-switcher-loader';
            const scriptEl = document.createElement('script');
            scriptEl.id = `${idPrefix}-script`;
            scriptEl.src = '/account-switcher/dropdown-assets-loader.js';
            scriptEl.setAttribute('data-test-tag', `${idPrefix}-script`);
            document.head.appendChild(scriptEl);
        },
    },
    mounted() {
        this.appendScriptsToDom();
    },
};
</script>

<style lang="scss" scoped>
$grid-breakpoint-md: 1064px;

#dropdown-account-switcher-container {
    align-items: center;
    display: flex;
    height: 48px;

    --gaps-dropdown-header-max-width: 320px;

    @media (width >= $grid-breakpoint-md) {
        --gaps-dropdown-header-max-width: 400px;
    }
}

.account-switcher-fallback {
    font-size: 12px;
    line-height: 16px;
}
</style>
